import React, { forwardRef, useImperativeHandle, useState } from 'react';
import PropTypes from 'prop-types';

import RestUploadFile from 'components/RestInput/RestUploadFile';

import { getPrefixKeyUploadCentre } from 'utils/fileUtils';
import { useParams } from 'react-router';
import CentreModal from '.';

const CentrePhotoModal = forwardRef(({ visible, record, onCancel }, ref) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const { id } = useParams();

  const [visibleModal, setVisibleModal] = useState(false);

  const onCancelModal = () => setVisibleModal(false);

  useImperativeHandle(
    ref,
    () => ({
      toggleModal: () => {
        setVisibleModal(true);
      },
    }),
    [],
  );

  return (
    <CentreModal
      title="centreDetail.titleCentrePhotoModal"
      visible={visible || visibleModal}
      onCancel={onCancel || onCancelModal}
      isDisabled={isDisabled}
    >
      <RestUploadFile
        setIsDisabled={setIsDisabled}
        record={record}
        source="images"
        onlyShowImg
        isSetFeature
        isAttachURLVideo
        isDrapDrop
        prefixKey={getPrefixKeyUploadCentre(id)}
      />
    </CentreModal>
  );
});

CentrePhotoModal.propTypes = {
  record: PropTypes.object,
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
};

export default CentrePhotoModal;
